const { __FS_API_URL__ } = global

export const addressLookup = async (
  postcode: string,
  setAddresses: (data: any) => void,
  setPostcodeNotFound: (value: boolean | ((prevState: boolean) => boolean)) => void,
) => {
  const apiPath: string = __FS_API_URL__ || 'https://money.co.uk/api'

  const response = await fetch(`${apiPath}/address/${postcode}`)
  const { data } = await response.json()
  if (data.length === 0) {
    setPostcodeNotFound(true)
  }
  setAddresses(data)
}
